const i18nKeyPrefix: string = 'STAFF-SIGNUP'
export { default } from './StaffSignUp'
export { i18nKeyPrefix }
